module.exports = __webpack_public_path__ + "static/media/front-left.16665832.svg";